import { render, staticRenderFns } from "./PageBreakSettings.vue?vue&type=template&id=45e18933&scoped=true"
import script from "./PageBreakSettings.vue?vue&type=script&lang=js"
export * from "./PageBreakSettings.vue?vue&type=script&lang=js"
import style0 from "./PageBreakSettings.vue?vue&type=style&index=0&id=45e18933&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e18933",
  null
  
)

export default component.exports